import { useMemo } from 'react'
import { useLocation, useParams } from 'react-router-dom'

export function usePathSegment() {
  const location = useLocation()
  const params = useParams()

  return useMemo(() => {
    if (params.tab) {
      return params.tab
    }

    const pathSegments = location.pathname.split('/').filter(Boolean)
    return pathSegments[pathSegments.length - 1]
  }, [location.pathname, params.tab])
}

export default usePathSegment
